'use client'

import { usePrevious } from '@mantine/hooks'
import { cn } from '@qr-front/ui/utils'
import { motion } from 'motion/react'

import { TPhonePreviewProps } from './PhonePreviewTypes'

export const ContentWrapperWithTransition = ({
	content,
	contentKey,
	isQrPreview,
	id,
	className,
}: Omit<TPhonePreviewProps, 'placeholder'> & {
	id?: string
	className?: string
}) => {
	const prevContentKey = usePrevious(contentKey)

	const hasContentChanged =
		contentKey &&
		(prevContentKey === undefined || contentKey === prevContentKey)

	const shouldAnimateContentEnter = !isQrPreview && !!hasContentChanged

	return content ? (
		<motion.div
			key={contentKey}
			id={id}
			initial={{
				opacity: content ? (shouldAnimateContentEnter ? 1 : 0) : 0,
			}}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			className={cn('h-full', className)}
		>
			{content}
		</motion.div>
	) : null
}
